// 新建任务页面
import React from "react";
import { Upload, message, Form, Input, Button, Table, Spin } from "antd";
import fetchHandler from "@/fetch/fetchHandler";
import { updateTask, prefixFile, getStubCfgTableInfo, executeTask } from "@/fetch/fetchApi";
// 国际化切换语言
import { injectIntl } from "react-intl";
import { TableLocale } from "@/utils/publicParam";
// 样式
import "./index.styl";
// 图片
import successIcon from "@/assets/img/taskManage/successIcon.png";

class TaskBuildStep1 extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.cfgChangeTaskBuild;
    this.state = {
      fileName: "",
      buttonDescrible: this.props.intl.messages.cfgChangeTaskBuild.btn1, // "配置上传",
      resultArray: [],
      tableConfig: {},
      headerTemp: [],
      zhHeader: [],
      bodyTemp: [],
      resultArrayTemp: [],
      data: [],
      tableColumns: [],
      errCount: "", // 异常数量
      normalCount: "", // 正常数量
      allCount: "", // 校验数量
      dobtnDisabled: true,
      doLoading: false,
      hasError: false,
      btnLoading: false,
      spinning: false,
      btnDisabled2: false,
    };
    // this.init();
  }

  fetch() {
    console.log("fecth 方法执行");
    // 表格加载效果
    this.setState({
      tableLoading: true,
      spinning: true,
    });
    fetchHandler(getStubCfgTableInfo, {
      taskName: this.props.taskName,
      taskId: this.props.taskId,
    }).then((res) => {
      if (res && res.code === "success" && res.data) {
        const result = res.data;
        this.state.errCount = result.errorCount;
        this.state.normalCount = result.normalCount;
        this.state.allCount = result.cfgData.length;
        this.state.zhHeader = [];
        this.state.resultArrayTemp = [];
        this.state.bodyTemp = [];
        for (let i = 0; i < result.cfgData.length; i++) {
          const resultArray1 = {};
          Object.keys(result.cfgData[i]).forEach((key) => {
            resultArray1[key] = result.cfgData[i][key];
          });
          this.state.resultArrayTemp.push(resultArray1);
        }
        // 头部信息
        const enHeader = result.enHeader;
        this.state.zhHeader = result.zhHeader;
        for (let i = 0; i < this.state.zhHeader.length; i++) {
          if (i === 0) {
            this.state.bodyTemp.push({
              title: this.state.zhHeader[i],
              dataIndex: enHeader[i],
              align: "center",
              colType: "textCol",
              fixed: true,
              width: 50,
              render: (text) => {
                if (text && text.match("errMsg")) {
                  return <div style={{ color: "red" }}>{text}</div>;
                } else {
                  return <div>{text || "--"}</div>;
                }
              },
            });
          } else {
            this.state.bodyTemp.push({
              title: this.state.zhHeader[i],
              dataIndex: enHeader[i],
              align: "center",
              colType: "textCol",
              render: (text) => {
                if (text && text.match("errMsg")) {
                  return <div style={{ color: "red" }}>{text}</div>;
                } else {
                  return <div>{text || "--"}</div>;
                }
              },
            });
          }
        }
        this.setState({
          bodyTemp: this.state.bodyTemp,
        });
      } else {
        this.setState({
          spinning: false,
        });
      }
    });
  }

  addTable() {
    this.setState({
      tableColumns: this.state.bodyTemp,
      spinning: false,
    });
  }

  handleExportBtnClick = () => {
    const excelUrl = `${prefixFile}/exportUploadStubCfg.do`;
    const params = `taskName=${this.props.taskName}&&taskId=${this.props.taskId}`;
    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${params}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${params}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  // 设置Form的ref
  formRef = React.createRef();

  componentWillReceiveProps(nextProps) {
    if (nextProps.refresh !== this.props.refresh) {
      // 调用接口获取数据
      this.fetch();
      // 数据填充表格
      this.addTable();
    }
  }

  init() {
    // 调用接口获取数据
    this.fetch();
    // 数据填充表格
    this.addTable();
  }

  handleUpdateTaskBtnClick = () => {
    // 获取备注
    const info = this.formRef2.current.getFieldsValue();
    console.log(info);
    console.log(this.state.bodyTemp);
    if (this.state.bodyTemp.length === 0) {
      message.warning("配置内容不能为空！");
    } else {
      // 往数据库任务表更新一条数据 增加备注信息
      fetchHandler(updateTask, {
        taskName: this.props.taskName,
        taskId: this.props.taskId,
        comments: info.comments,
      }).then((res) => {
        // 保存成功 关闭窗口
        if (res && res.code === "success") {
          //  message.success(this.internationalization.msg2);
          // 执行 任务
          this.todoTask();
        }
      });
    }
  };

  goBack = () => {
    this.props.changeStep(1, false);
  };

  // 执行任务
  todoTask = () => {
    this.setState({
      doLoading: true,
      dobtnDisabled: true,
    });
    fetchHandler(executeTask, {
      taskName: this.props.taskName,
      taskId: this.props.taskId,
      userName: this.props.createAccount,
    }).then((result) => {
      this.setState({
        doLoading: false,
      });
      if (result && result.code === "success") {
        this.setState({
          btnDisabled2: true,
        });
        message.success(this.internationalization.msg2);
        this.props.changeStep(3, false);
      }
    });
  };

  // 设置Form的ref
  formRef2 = React.createRef();

  render() {
    const uploadProps = {
      name: "file",
      multiple: false,
      accept: ".xls",
      action:
        `${prefixFile}/oss/importStubCfg.do?taskName=${
          this.props.taskName
        }&taskId=${this.props.taskId} `,
      headers: {
        authorization: "authorization-text",
      },
      showUploadList: false,
      // progress:{
      //     type:'line'
      // },
      onChange: (info) => {
        console.log(info);
        this.setState({
          btnLoading: true,
        });
        if (info.file.response !== undefined && info.file.response === 1) {
          this.setState({
            btnLoading: false,
          });
          this.state.display = "";
          message.success(info.file.name + this.internationalization.msg3);
          this.state.fileName = info.file.name;
          this.state.buttonDescrible = this.internationalization.msg4;
          this.props.setFileName(info.file.name);
          this.init();
        } else if (info.file.response !== undefined && info.file.response.status !== "200") {
          this.setState({
            btnLoading: false,
          });
          message.error(`${info.file.name}上传失败`);
        }
      },
    };
    const content = (
      <div className="step2-content">
        <Spin spinning={this.state.spinning}>
          <div className="success-result-show">
            <img alt="" className="success-icon" src={successIcon} />
            <div className="success-wz">校验已完成</div>
            <div className="file-name">{this.props.fileName}</div>
            {/* <div><img className="excle" src={excelIcon} />设备订单模板.xls </div> */}
          </div>
          <div className="result-info-show">
            <div className="tip-info-num">
              校验数量：<span className="num-col">{this.state.allCount || 0}</span>
            </div>
            <div className="tip-info-num">
              正常数量：<span className="num-col">{this.state.normalCount || 0}</span>
            </div>
            <div className="tip-info-num">
              异常数量：<span className="num-col error-num">{this.state.errCount || 0}</span>
            </div>
          </div>
          <div className="table-config-title">
            <div className="title">配置内容</div>
            {this.state.errCount > 0 ? (
              <div className="tips-info" style={{ textAlign: "right", flex: 1, padding: "0 40px" }}>
                注:此处下载的配置文件里面会标注出异常配置内容
              </div>
            ) : null}
            <Button
              className="peizhi-download"
              onClick={() => {
                this.handleExportBtnClick();
              }}>
              配置下载
            </Button>
          </div>
          <div className="table-content">
            <Table
              columns={this.state.bodyTemp}
              dataSource={this.state.resultArrayTemp}
              bordered
              locale={TableLocale}
              className="sc-table"
              footer={
                this.state.resultArrayTemp && this.state.resultArrayTemp.length
                  ? () => <div></div>
                  : null
              }
              scroll={{ x: "50%" }}
            />
          </div>
          <div className="bz-content ">
            <Form ref={this.formRef2}>
              <Form.Item label="备注" name="comments">
                <Input style={{ width: 200 }} placeholder="请输入备注内容" />
              </Form.Item>
              <Form.Item className="btn-group">
                <Upload {...uploadProps}>
                  <Button
                    type="primary"
                    loading={this.state.btnLoading}
                    disabled={this.state.btnLoading || this.state.btnDisabled2}>
                    重新上传
                    {/* <UploadOutlined />{this.state.buttonDescrible} */}
                  </Button>
                </Upload>
                <Button
                  disabled={this.state.errCount > 0}
                  loading={this.state.doLoading}
                  onClick={this.handleUpdateTaskBtnClick}
                  type="primary">
                  批量修改
                </Button>
                {/* <Button className="peizhi-download"  onClick={this.goBack}>返回上一级</Button> */}
              </Form.Item>
            </Form>
          </div>
        </Spin>
      </div>
    );
    return content;
  }
}

export default injectIntl(TaskBuildStep1);



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/taskManagement/taskBuildStep2.js